import React, { useState } from 'react';
import { makeStyles, IconButton } from '@material-ui/core';
import { AddCircle as AddCircleIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';

import { selectBrandNotes } from 'selectors/brand';
import { addNote, updateNote, deleteNote } from 'modules/brand';
import Note from './Note';

const useStyles = makeStyles(() => ({
  title: {
    margin: '0 0 10px',
    display: 'flex',
    fontSize: '18px',
    alignItems: 'center',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 -10px',
  },
  empty: {
    fontSize: '14px',
    margin: '0 0 0 10px',
    fontStyle: 'italic',
    color: 'rgba(0, 0, 0, 0.5)',
  },
}));

const Notes = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const notes = useSelector(selectBrandNotes);
  const [isCreate, setIsCreate] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const showSuccess = (message) => {
    enqueueSnackbar(message, { variant: 'success' });
  };

  const showError = (message) => {
    enqueueSnackbar(message, { variant: 'error' });
  };

  const handleAdd = (note) => {
    dispatch(addNote(note))
      .then(() => {
        showSuccess('Note Created');
        setIsCreate(false);
      })
      .catch(error => {
        showError(error);
        setIsCreate(false);
      });
  };

  const handleUpdate = (note) => {
    dispatch(updateNote(note))
      .then(() => {
        showSuccess('Note Saved!');
      })
      .catch((error) => {
        showError(error);
      });
  };

  const handleDelete = (note) => {
    dispatch(deleteNote(note.id))
      .then(() => {
        showSuccess(`Note Deleted.`);
      })
      .catch((error) => {
        showError(error);
      });
  };

  const toggleCreate = () => {
    setIsCreate(!isCreate);
  };

  const renderNote = (note) => {
    return (
      <Note
        key={note.id}
        note={note}
        handleUpdate={handleUpdate}
        handleDelete={handleDelete}
      />
    );
  };

  return (
    <>
      <h2 className={classes.title}>
        Notes
        <IconButton onClick={toggleCreate} className="profile-notes-toggle">
          <AddCircleIcon />
        </IconButton>
      </h2>
      <div className={classes.wrapper}>
        {(notes.length > 0 || isCreate) ? notes.map(renderNote) : <p className={classes.empty}>No notes have been entered.</p>}
        {isCreate && (
          <Note
            note={{ note: '' }}
            handleAdd={handleAdd}
            toggleCreate={toggleCreate}
            create
          />
        )}
      </div>
    </>
  );
};

export default Notes;
